import MuiFormHelperText from '@mui/material/FormHelperText';

import { styled } from 'helpers';

import { FormHelperTextProps } from './';

export const FormHelperText = styled(MuiFormHelperText)<FormHelperTextProps>`
  margin-left: 0;
  margin-top: 4px;
  color: ${({ theme }) => theme.palette.blueGrey['A600']};
  &.Mui-error:not(.Mui-disabled) {
    color: ${({ theme }) => theme.palette.deepOrange['900']};
  }
  &.Mui-disabled {
    color: ${({ theme }) => theme.palette.blueGrey['A600']};
  }
`;
FormHelperText.displayName = 'FormHelperText';
